import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { PageFormModule } from '../page-form/page-form.module';
import { PageTemplateWindowModule } from '../page-template-window/page-template-window.module';
import { SectionFormModule } from '../section-form/section-form.module';
import { SectionInfoModule } from '../section-info/section-info.module';
import { KYMW2401Module } from '../kymw2401/kymw2401.module';
import { KYMW2403Module } from '../kymw2403/kymw2403.module';

import { KYMW2400Component } from './kymw2400.component';

import { AppCommonsModule } from '../../../commons/app-commons.module';

import { CancelDataService } from './api-services/cancel-data.service';
import { DeleteSectionService } from './api-services/delete-section.service';
import { DeleteTemplateService } from './api-services/delete-template.service';
import { GetAllPageTemplateService } from './api-services/get-all-page-template.service';
import { GetPageTemplateInfoService } from './api-services/get-page-template-info.service';
import { RegistNewTemplateService } from './api-services/regist-new-template.service';
import { SelectSectionService } from './api-services/select-section.service';
import { UpdateTemplateService } from './api-services/update-template.service';

/**
 * 特別指示書画面 モジュール設定クラス
 *
 * @export KYMW2400Module
 * @class KYMW2400Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjInputModule,
    PageFormModule,
    PageTemplateWindowModule,
    SectionFormModule,
    SectionInfoModule,
    KYMW2401Module,
    KYMW2403Module,
  ],
  declarations: [
    KYMW2400Component,
  ],
  providers: [
    CancelDataService,
    DeleteSectionService,
    DeleteTemplateService,
    GetAllPageTemplateService,
    GetPageTemplateInfoService,
    RegistNewTemplateService,
    SelectSectionService,
    UpdateTemplateService,
  ],
})
export class KYMW2400Module {
}
